<template>
  <div class="homepage">
    <!--    <img src="../../assets/images/welcome.png" alt="" class="welcome">-->
    <div class="homepage-bg" />
  </div>
</template>
<script>
import { ADMIN_SCOPE } from '../../permission/const';
import { mapState } from 'vuex';
export default {
  data() {
    return {
      ADMIN_SCOPE,
      activeTab: '',
      tabs: [],
    };
  },
  computed: {
    ...mapState('user', ['roles']),
  },
  mounted() {
  },
  methods: {},
};
</script>
<style lang="less" scoped>
    .homepage {
      display: flex;
      width: 100%;
      height: calc(100vh - 66px);
      //margin-top: 16px;
      //margin-bottom: 16px;
      justify-items: center;
      align-items: center;
      //background: url(../.url./assets/images/welcome.png) no-repeat;
      //background-size: cover;
      .homepage-bg {
        width: 100%;
        height: 100%;
        background: url(../../assets/images/welcome.png) no-repeat;
        background-size: cover;
      }
        .welcome{
          width: 1099px;
          margin: 0 auto;
        }
    }
</style>
